import request from '@/utils/edu_request'
// 视频信息
export function getVideoInfo(params) {
  return request({
    url: '/lesson/lesson/play',
    method: 'get',
    params
  })
}
// 问答列表
export function getQAlist(params) {
  return request({
    url: '/lesson/lesson/getQaList',
    method: 'get',
    params
  })
}
// 发布问答
export function sends(params) {
  return request({
    url: '/lesson/lesson/saveQa',
    method: 'get',
    params
  })
}
// 课程播放-记录用户操作行为日志
export function statistic(params) {
  return request({
    url: '/lesson/lesson/statistic',
    method: 'get',
    params
  })
}
